export const AWSConfig = {
  bucketName: 'cranefields',
  region: 'eu-west-1',
  accessKeyId: 'AKIAU3ONUHCXET2DYWN5',
  secretAccessKey: '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',
};